import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { ReactNode } from 'react';

import { wagmiConfig } from 'modules/api/web3/appKit';

import { CryptoWalletListener } from '../CryptoWalletListener';
import { WrongNetworkWorkaroundListener } from '../WrongNetworkWorkaroundListener';

const queryClient = new QueryClient();

interface IWeb3ProviderProps {
  children?: ReactNode;
}

export const Web3Provider = ({ children }: IWeb3ProviderProps) => {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <CryptoWalletListener />

        <WrongNetworkWorkaroundListener />

        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
};
